import { useMutation } from '@apollo/client';
import { VIEW_FRONT_RECENT_REVIEWS } from '../../graphql/user-mutations';

export default function useMutateViewRecentReviews() {
    const [mutateViewRecentReviews] = useMutation(VIEW_FRONT_RECENT_REVIEWS);
    return { mutateViewRecentReviews };
}
